import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  styleOfDropdown: {
    color: `${theme.palette.text.primary} !important`,
    '& .text': {
      color: theme.palette.primary.main,
    },
    '& .item': {
      color: theme.palette.primary.main,
    },
  },
}));
